export function scrollToElementById(
    id: string,
    extraOffset: number = 0, // Set to true if no need to scroll when element is in viewPort
    checkIfInViewPort: boolean = false
) {
    const elmnt = document.getElementById(id);
    if (elmnt) {
        const getClientRect = elmnt.getBoundingClientRect();

        if (checkIfInViewPort && isInViewPort(elmnt)) return;

        const y = getClientRect.top + window.pageYOffset - extraOffset;

        window.scrollTo({ top: y, behavior: "smooth" });
    }
}

export function scrollToElement(
    element: HTMLElement,
    extraOffset: number = 0, // Set to true if no need to scroll when element is in viewPort
    checkIfInViewPort: boolean = false
) {
    if (element) {
        const getClientRect = element.getBoundingClientRect();

        if (checkIfInViewPort && isInViewPort(element)) return;

        const y = getClientRect.top + window.pageYOffset - extraOffset;

        window.scrollTo({ top: y, behavior: "smooth" });
    }
}

export function scrollToPosition(
    position: number,
    behavior: ScrollBehavior = "auto"
) {
    window.scrollTo({ top: position, behavior: behavior });
}

export function isInViewPort(element: HTMLElement) {
    const getClientRect = element.getBoundingClientRect();
    return (
        getClientRect.top >= 0 &&
        getClientRect.left >= 0 &&
        getClientRect.bottom <=
            (window.innerHeight || document.documentElement.clientHeight) &&
        getClientRect.right <=
            (window.innerWidth || document.documentElement.clientWidth)
    );
}

export function scrollToTop(behavior: ScrollBehavior = "smooth") {
    window.scroll({
        top: 0,
        left: 0,
        behavior: behavior
    });
}
